export enum HeatDistributionTypeEnum {
  FloorHeating = 'floor_heating',
  FloorHeatingSparse = 'floor_heating_sparse',
  FloorHeatingAndCooling = 'floor_heating_and_cooling',
  FloorHeatingAndCoolingSparse = 'floor_heating_and_cooling_sparse',
  WallHeatingAndCooling = 'wall_heating_and_cooling',
  CeilingHeatingAndCooling = 'ceiling_heating_and_cooling',
  FloorWallAndCeilingHeating = 'floor_wall_and_ceiling_heating',
}
